import { deepCopy } from "../../../../../utils/deepCopy"
import { toast } from "../../../../../utils/messageUtils"

export const addMultipleSelectionQuestion = (state, payload) => {
    let goals = addMultipleSelectionQuestionToGoals(state, payload)
    return {
        ...state,
        goals: goals
    }
}

const addMultipleSelectionQuestionToGoals = (state, payload) => {
    let goalsCopy = deepCopy(state.goals)
    goalsCopy.forEach(item => {
        if (item.goalId === "multipleOption") {
            item.questions.splice(item.questions.length, 0, payload.data)
        }
    })
    toast.success("Question added successfully")
    return goalsCopy
}